<template>
  <section id="delivery" class="s-shop-select__item">
    <div class="s-shop-options">
      <div class="s-kicker">{{ translations.slang_shipping_kicker }}</div>
      <div class="s-heading s-heading--3">
        <span class="s-heading__text">{{ translations.slang_shipping_headline }}</span>
      </div>
      <p class="s-copy">{{ translations.slang_shipping_intro }}</p>
      <div class="s-shop-option" :class="[{'--is-disabled': cameraAvailable === false, '--is-selected': deliveryType === 'now'}]" @click="handleDeliveryChange('now')">
        <header class="s-shop-option__header">
          <div class="s-shop-option__name">{{ translations.slang_shipping_instant }}</div>
        </header>
        <p class="s-copy s-copy--s s-shop-option__description">{{ translations.slang_shipping_instant_desc }}<span v-if="deliveryTime"><br><b>{{ translations.slang_shipping_time }} </b>{{ deliveryTime }}</span></p>
      </div>
      <div class="s-shop-option" :class="[{'--is-selected': deliveryType === 'date'}]" @click="handleDeliveryChange('date')">
        <header class="s-shop-option__header">
          <div class="s-shop-option__name">{{ translations.slang_shipping_select_date }}</div>
          <div class="s-shop-option__price">
          </div>
        </header>
        <p class="s-copy s-copy--s s-shop-option__description">{{ translations.slang_shipping_desired_date }}</p>
        <div class="s-form">
          <div class="s-form-item s-form-item--half-left">
            <input :value="deliveryDateMin" :min="deliveryDateMin" :max="deliveryDateMax" class="s-form-item__field" type="date" @input="updateDate">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapState} from "vuex";

export default {
  computed: {
    wpData() {
      return this.$store.getters.wpdata[wpGlobalData.language];
    },
    translations(){
      return this.$store.state.wpdata[wpGlobalData.language].translations.slang_shipping[0];
    },
    cameraAvailable() {
      return this.$store.state.available;
    },
    deliveryType() {
      return this.$store.state.delivery_type;
    },
    deliveryTime() {
      return this.$store.state.selections.selected_camera.shop_camera_options_delivery;
    },
    deliveryDateMin() {
      return this.$store.state.delivery_date_min;
    },
    deliveryDateMax() {
      console.log(this.$store.state.delivery_date_max);
      return this.$store.state.delivery_date_max;
    },
    ...mapState({
      delivery_date: state => state.delivery_date,
    })
  },
  data() {
    return {
      wpGlobalData
    };
  },
  methods: {
    handleDeliveryChange(type){
      if(type === 'date' || (type === 'now' && this.cameraAvailable === true)){
        this.$store.commit('setDeliveryType', type)
      }
    },
    updateDate(e){
      this.$store.commit('setDeliveryDate', e.target.value)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StepPreorder.vue